import { useQuery } from '@tanstack/react-query';
import { feedApi } from '../api';

export function useUserProfile(userId: string | null) {
  return useQuery({
    queryKey: ['feed', 'userProfile', userId],
    queryFn: async () => {
      const { data } = await feedApi.getUserProfile(userId!);
      return data.profile;
    },
    enabled: !!userId,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
}
